import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const OneOfOneLuxuryVideo = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url="https://yuriy-dmytrash19.wistia.com/medias/oj6tslcxka"
        maxHeight="80%"
      />
    </>
  );
};

export default OneOfOneLuxuryVideo;
